import { TextField } from '@atgfr8/atg-ui-tailwind';

function DisabledTextField(props: {
  value: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <TextField
      value={props.value}
      dataTestId={'disabled-textInput'}
      disabled
      class={'bg-slate-100 rounded-md'}
      label=""
      size={props.size}
    />
  );
}

export default DisabledTextField;
